import { render, staticRenderFns } from "./ClientGoods.vue?vue&type=template&id=2d4d0c14&scoped=true"
import script from "./ClientGoods.vue?vue&type=script&lang=js"
export * from "./ClientGoods.vue?vue&type=script&lang=js"
import style0 from "./ClientGoods.vue?vue&type=style&index=0&id=2d4d0c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d0c14",
  null
  
)

export default component.exports